import React, { Component } from 'react'
import { Card, Row, Col, Button, Modal, message } from 'antd'
import styled from 'styled-components'
import {
    LayoutOutlined,
    DownloadOutlined,
    LoadingOutlined
} from '@ant-design/icons'
import { getTemplates, setTemplate } from '../../services/apiServices'
import LoadingModal from '../../commons/Modal/Loading'

const Container = styled(Card)``

class StarterTemplates extends Component {
    state = {
        isLoading: false,
        templates: [],
        installingId: 0,
        installedId: 0
    }

    componentDidMount() {
        this.getTemplates()
    }

    async getTemplates() {
        this.setState({ isLoading: true })
        try {
            let templates = await getTemplates()
            this.setState({
                isLoading: false,
                templates
            })
        } catch (error) {
            this.setState({ isLoading: false })
            message.error(this.props.T('SOMETHING_WRONG'))
        }
    }

    async setTemplate(id = 1) {
        this.setState({ isLoading: true, installingId: id })
        try {
            await setTemplate({
                body: {
                    id
                }
            })
            this.setState({
                isLoading: false,
                installingId: 0,
                installedId: id
            })
            message.success(this.props.T('INSTALLED'))
        } catch (error) {
            this.setState({ isLoading: false })
            message.error(this.props.T('SOMETHING_WRONG'))
        }
    }

    onInstall(id) {
        showInstallConfirm(this.props.T.bind(this), () => {
            this.setTemplate(id)
        })
    }

    render() {
        let { T } = this.props

        return (
            <Container
                title={
                    <span className="text-xl">
                        <LayoutOutlined /> {T('STARTER_TEMPLATES')}
                    </span>
                }>
                <Row gutter={[0, 50]}>
                    {this.state.templates.map(id => (
                        <Col
                            xs={24}
                            sm={12}
                            lg={12}
                            xl={8}
                            key={id}
                            style={{
                                display: 'flex',
                                justifyContent: 'center'
                            }}>
                            <Card
                                style={{ width: '85%' }}
                                type="inner"
                                title={`Template ${id}`}
                                extra={
                                    <Button
                                        size="middle"
                                        type="primary"
                                        icon={
                                            this.state.installingId == id ? (
                                                <LoadingOutlined />
                                            ) : (
                                                <DownloadOutlined />
                                            )
                                        }
                                        onClick={() => this.onInstall(id)}>
                                        {this.state.installedId == id
                                            ? T('INSTALLED')
                                            : T('INSTALL')}
                                    </Button>
                                }
                                cover={
                                    <div
                                        style={{
                                            height: 300,
                                            width: '100%',
                                            border: '1px solid #f0f0f0',
                                            overflowY: 'auto'
                                        }}>
                                        <img
                                            style={{
                                                width: '100%'
                                            }}
                                            src={`${window.config.themeUrl}/manager/static/images/template-demo/${id}.jpg`}
                                        />
                                    </div>
                                }
                                bodyStyle={{ display: 'none' }}></Card>
                        </Col>
                    ))}
                </Row>

                <LoadingModal isOpen={this.state.isLoading} />
            </Container>
        )
    }
}

const showInstallConfirm = (T, onOk) => {
    Modal.confirm({
        title: T('CONFIRM_INSTALL_TEMPLATE_MSG'),
        content: T('CONFIRM_INSTALL_TEMPLATE_DESC'),
        okType: 'danger',
        okText: T('CONFIRM'),
        cancelText: T('CANCEL'),
        maskClosable: true,
        centered: true,
        onOk() {
            onOk()
        },
        onCancel() {
            console.log('Cancel')
        }
    })
}

export default StarterTemplates
